import { render, staticRenderFns } from "./CustomFieldsView.vue?vue&type=template&id=edaab1d6&"
import script from "./CustomFieldsView.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports